import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import CaseStudyDetail from './pages/CaseStudyDetail';
import CreateCaseStudyNew from './pages/CreateCaseStudyNew';
import CreateHub from './pages/CreateHub';
import CreateTest from './pages/CreateTest';
import CreateMockExam from './pages/CreateMockExam';
import MockExam from './pages/MockExam';
import Videos from './pages/Videos';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import Test from './pages/Test';
import Student from './pages/Student';
import AdminSetupPage from './pages/AdminSetupPage';
import { Toaster } from './components/ui/sonner';
import { api } from './utils/api';
import '@/App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    // Check existing session
    try {
      const response = await api.get('/auth/me');
      setUser(response.data);
    } catch (error) {
      console.log('Not authenticated');
    }
    setLoading(false);
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
      setUser(null);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600"></div>
          <p className="mt-4 text-teal-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<Dashboard user={user} logout={logout} />} />
          <Route path="/case-study/:id" element={<CaseStudyDetail user={user} logout={logout} />} />
          <Route path="/create" element={user && (user.is_admin || user.is_study_master) ? <CreateHub user={user} logout={logout} /> : <Navigate to="/dashboard" />} />
          <Route path="/create/case-study" element={user && (user.is_admin || user.is_study_master) ? <CreateCaseStudyNew user={user} logout={logout} /> : <Navigate to="/dashboard" />} />
          <Route path="/create/test/:difficulty" element={user && user.is_admin ? <CreateTest user={user} logout={logout} /> : <Navigate to="/dashboard" />} />
          <Route path="/create/mock-exam" element={user && user.is_admin ? <CreateMockExam user={user} logout={logout} /> : <Navigate to="/dashboard" />} />
          <Route path="/profile/:userId" element={user ? <Profile user={user} logout={logout} /> : <Navigate to="/dashboard" />} />
          <Route path="/admin" element={user ? <Admin user={user} logout={logout} /> : <Navigate to="/dashboard" />} />
          <Route path="/test/:difficulty" element={<Test user={user} logout={logout} />} />
          <Route path="/mock-exam" element={<MockExam user={user} setUser={setUser} />} />
          <Route path="/videos" element={user ? <Videos user={user} logout={logout} /> : <Navigate to="/dashboard" />} />
          <Route path="/student" element={user ? <Student user={user} logout={logout} /> : <Navigate to="/dashboard" />} />
          <Route path="/admin-setup" element={<AdminSetupPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;